<section class="settings-panel">
  <!-- Appearance -->
  @if (currentUserDetails) {
    <div class="user-settings-wrapper">
      <div class="avatar-wrapper">
        <div class="avatar-icon">
          <span class="fa-stack fa-sm fg-ac-icon-stack">
            <i class="fa fa-circle fa-stack-2x fg-value-fl-circle" aria-hidden="true"></i>
            <i class="fa fa-stack-1x fa-inverse fg-value-fl-value" aria-hidden="true">
            {{extractFirstLetters(currentUserDetails?.userName)}}</i>
          </span>
        </div>
        <button mat-icon-button class="logout-btn" matTooltip="Sign out" (click)="openLogoutDialog()">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
      <div class="user-info">
        <h2 class="user-name"> Hi {{currentUserDetails?.userName}} </h2>
        <div class="org-name">{{currentUserDetails?.orgCode}}</div>
        <div class="last-login"> @if (currentUserDetails?.lastLoginTime) {
          Last Login : {{currentUserDetails?.lastLoginTime | date:'MMM dd,yyyy, h:mm:ss a'}}
        }
        @if (!currentUserDetails?.lastLoginTime) {
          Last Login :
        }</div>
      </div>
      <mat-divider></mat-divider>
      <div class="user-actions">
        <button mat-fab extended (click)="logout(true)">
          <mat-icon>switch_account</mat-icon>
          Switch Account
        </button>
      </div>
    </div>
  }

  @if (!currentUserDetails) {
    <div class="user-settings-wrapper">
      <div class="avatar-wrapper">
        <div class="avatar-icon">
          <span class="fa-stack fa-sm fg-ac-icon-stack">
            <i class="fa fa-circle fa-stack-2x fg-value-fl-circle" aria-hidden="true"></i>
            <i class="fa fa-stack-1x fa-inverse fg-value-fl-value" aria-hidden="true">
            {{extractFirstLetters('Guest')}}</i>
          </span>
        </div>
        <button mat-icon-button class="logout-btn" matTooltip="Sign out" (click)="goToLogin()">
          <mat-icon>login</mat-icon>
        </button>
      </div>
      <div class="user-info">
        <h2 class="user-name"> Hi Guest </h2>
      </div>
      <mat-divider></mat-divider>
      <div class="user-actions">
        <button mat-fab extended (click)="goToLogin()">
          <mat-icon>login</mat-icon>
          Login
        </button>
      </div>
    </div>
  }

  <mat-divider class="settings-divider"></mat-divider>

  <div class="section">
    <label>Appearance</label>
    <div class="theme-grid">
      @for (t of themes; track t) {
        <div class="theme-item" (click)="setTheme(t.class)"
          [class.selected]="currentTheme === t.class">
          <div class="swatch-stack">
            <div class="swatch-block" [style.background-color]="t.primaryColor"></div>
            <div class="swatch-block" [style.background-color]="t.accentColor"></div>
            <div class="swatch-block" [style.background-color]="t.warnColor"></div>
          </div>
          <div class="theme-label">{{ t.label }}</div>
        </div>
      }

    </div>
  </div>

  <div class="section">
    <label>View Preferences</label>

    <div class="subsection">
      <label>Direction</label>

      <mat-button-toggle-group name="direction" [value]="direction" (change)="setDirection($event.value)" exclusive
        appearance="legacy">
        <mat-button-toggle value="ltr">LTR</mat-button-toggle>
        <mat-button-toggle value="rtl">RTL</mat-button-toggle>
      </mat-button-toggle-group>

    </div>

    <div class="subsection">
      <label>Layout</label>
      <div class="layout-cards">
        <div class="layout-card" [class.selected]="currentLayout === 'VERTICAL'" (click)="setLayout('VERTICAL')">

          <div class="layout-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 56" fill="none" aria-label="boron"
              class="h-[92px] w-full">
              <path fill="currentColor" d="M1 8a7 7 0 0 1 7-7h50a7 7 0 0 1 7 7v8H1V8Z" opacity="0.1"></path>
              <path fill="currentColor" fill-rule="evenodd"
                d="M58 1H8a7 7 0 0 0-7 7v40a7 7 0 0 0 7 7h50a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7ZM8 0a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h50a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Z"
              clip-rule="evenodd" opacity="0.1"></path>
              <path fill="currentColor" d="M5 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"></path>
              <path fill="currentColor"
                d="M5 21.5A1.5 1.5 0 0 1 6.5 20h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 5 21.5ZM5 33.5A1.5 1.5 0 0 1 6.5 32h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 5 33.5Z"
              opacity="0.7"></path>
              <path fill="currentColor"
                d="M5 27.5A1.5 1.5 0 0 1 6.5 26h11a1.5 1.5 0 0 1 0 3h-11A1.5 1.5 0 0 1 5 27.5ZM5 39.5A1.5 1.5 0 0 1 6.5 38h11a1.5 1.5 0 0 1 0 3h-11A1.5 1.5 0 0 1 5 39.5Z"
              opacity="0.4"></path>
              <path fill="currentColor" d="M48 8.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" opacity="0.7"></path>
              <path fill="currentColor"
                d="M53 8.5A1.5 1.5 0 0 1 54.5 7h5a1.5 1.5 0 0 1 0 3h-5A1.5 1.5 0 0 1 53 8.5ZM44 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM40 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
              opacity="0.4"></path>
              <path fill="currentColor" d="M32 24a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H36a4 4 0 0 1-4-4V24Z"
              opacity="0.1"></path>
            </svg>

          </div>
        </div>
        <div class="layout-card" [class.selected]="currentLayout === 'HORIZONTAL'" (click)="setLayout('HORIZONTAL')">

          <div class="layout-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 56" fill="none" aria-label="lithium"
              class="h-[92px] w-full">
              <!-- Outer Frame -->
              <path fill="currentColor" fill-rule="evenodd"
                d="M58 1H8a7 7 0 0 0-7 7v40a7 7 0 0 0 7 7h50a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7ZM8 0a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h50a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Z"
                clip-rule="evenodd" opacity="0.1" />

                <!-- Top Row -->
                <!-- Sleek Logo Dot (Top Left) -->
                <circle cx="8" cy="6" r="2.5" fill="currentColor" />

                <!-- Horizontally Aligned Settings Bars (Top Right) -->
                <rect x="50" y="5.5" width="5" height="1.5" rx="0.75" fill="currentColor" />
                <rect x="56" y="5.5" width="5" height="1.5" rx="0.75" fill="currentColor" />

                <!-- Divider -->
                <path fill="currentColor" d="M1 12h64v1H1z" opacity="0.1" />

                <!-- Second Row: Horizontal Menu Dashes -->
                <rect x="12" y="18" width="12" height="2" rx="1" fill="currentColor" />
                <rect x="27" y="18" width="12" height="2" rx="1" fill="currentColor" />
                <rect x="42" y="18" width="12" height="2" rx="1" fill="currentColor" />

                <!-- Main Box Section (unchanged) -->
                <path fill="currentColor" d="M4 29a5 5 0 0 1 5-5h48a5 5 0 0 1 5 5v18a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V29Z"
                  opacity="0.1" />
                </svg>


              </div>
            </div>
            <div class="layout-card" [class.selected]="currentLayout === 'ROUNDED'" (click)="setLayout('ROUNDED')">

              <div class="layout-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 56" fill="none" aria-label="lithium"
                  class="h-[92px] w-full">
                  <path fill="currentColor" fill-rule="evenodd"
                    d="M58 1H8a7 7 0 0 0-7 7v40a7 7 0 0 0 7 7h50a7 7 0 0 0 7-7V8a7 7 0 0 0-7-7ZM8 0a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8h50a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Z"
                  clip-rule="evenodd" opacity="0.1"></path>
                  <path fill="currentColor" d="M5 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"></path>
                  <path fill="currentColor"
                    d="M4 25a5 5 0 0 1 5-5h48a5 5 0 0 1 5 5v22a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V25Zm-3-8v-1h64v1H1Z"
                  opacity="0.1"></path>
                  <path fill="currentColor" d="M16 9.5A1.5 1.5 0 0 1 17.5 8h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 16 9.5Z"
                  opacity="0.7"></path>
                  <path fill="currentColor" d="M37 9.5A1.5 1.5 0 0 1 38.5 8h11a1.5 1.5 0 0 1 0 3h-11A1.5 1.5 0 0 1 37 9.5Z"
                  opacity="0.4"></path>
                </svg>

              </div>
            </div>
          </div>
        </div>
      </div>




      <!-- Mock Data -->
      <div class="section">
        <label>Mock Data</label>
        <mat-slide-toggle [checked]="mockDataEnabled" (change)="toggleMockData($event.checked)">
          {{ mockDataEnabled ? 'Disable Mock Data' : 'Enable Mock Data' }}
        </mat-slide-toggle>
      </div>